import { Spinner } from '@frontend/components/common';
import { SensorLockerStatus } from '@frontend/device/types';
import { IEquipment } from '@frontend/equipment/types';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import SmallSlotCard from '../../../components/slot-cards/small-slot-card.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import { useConfirmReturn } from './confirm-return.controller';

export const ConfirmReturn = () => {
    const viewProps = useConfirmReturn();

    if (viewProps.isLoading) {
        return (
            <WizardScreenContainer>
                <div className='flex h-full w-full items-center justify-center'>
                    <Spinner className='text-border-default fill-brand-primary size-12' />
                </div>
            </WizardScreenContainer>
        );
    }

    const canConfirm = viewProps.availableSlot !== null && !viewProps.isProcessing;

    return (
        <WizardScreenContainer
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.onSubmit,
                submitDisabled: !canConfirm,
                submitLabel: (
                    <FormattedMessage
                        id='kiosk.wizard.confirm-return.return-product'
                        defaultMessage='Return product'
                    />
                )
            }}>
            <div className='flex w-full flex-col gap-6'>
                <div className='flex flex-col gap-3 self-stretch'>
                    <p className='text-foreground-default font-medium'>{CommonMessage.BUTTONS.CONFIRMATION}</p>
                    <ProductCard
                        variant='attributes'
                        layout='vertical'
                        product={viewProps.product}
                        equipment={viewProps.equipment as IEquipment | undefined}
                    />
                </div>

                {/* Available slot */}
                {viewProps.availableSlot ? (
                    <div className='flex w-full flex-col gap-3'>
                        <p className='text-foreground-default font-medium'>
                            <FormattedMessage
                                id='kiosk.wizard.confirm-return.return-to-the-following-slot'
                                defaultMessage='Return to the following SLOT'
                            />
                        </p>
                        <div className='grid w-full grid-cols-2 gap-2'>
                            <SmallSlotCard
                                key={viewProps.availableSlot.id}
                                slot={viewProps.availableSlot}
                                status={SensorLockerStatus.CLOSED}
                            />
                        </div>
                    </div>
                ) : (
                    <div className='text-foreground-subtle text-center'>
                        <FormattedMessage
                            id='kiosk.wizard.confirm-return.no-slot-available'
                            defaultMessage='No SLOT available for this return'
                        />
                    </div>
                )}
            </div>
        </WizardScreenContainer>
    );
};
